import { createSlice } from "@reduxjs/toolkit";

const initialFAQState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  countryList: [],
  usersCount: null,
  allCountryList: null,
  newFAQ: {},
  FAQForEdit: {},
  itemFAQ: {},
  deleteFAQ: {},
 
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const FAQSlice = createSlice({

  name: "FAQ",
  initialState: initialFAQState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    FAQList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    createFAQ: (state, action) => {
      const { newFAQ } = action.payload;
      state.error = null;
      state.newFAQ = newFAQ;
    },
    deleteFAQ: (state, action) => {
      const { deleteFAQ } = action.payload;
      state.error = null;
      state.deleteFAQ = deleteFAQ;
    },
    singleItemFetched: (state, action) => {
      state.actionsLoading = false;
      state.FAQForEdit = action.payload.FAQForEdit;
      state.error = null;
    },

  }
});
